import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import ConditionalLink from '../../components/shared/ConditionalLink';
import SetTitle from '../../components/shared/SetTitle';
import HelpText from '../../components/help/HelpText';
import NoticeBox from '../../components/shared/NoticeBox';
import PopupBox from '../../components/shared/PopupBox';

import { formatNewLines } from '../../utilities/Generic.js'
import { spaceAndCapitalize } from '../../utilities/Forms.js'
import Audits from '../../components/shared/Audits';
import { request, handleRequestErrors } from '../../helpers/Requests'

class UpdateFireLog extends Component {
  constructor(props) {
    super(props);

    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSendEmail = this.handleSendEmail.bind(this);
  }

  state = {
    people: {
      visitor: [],
      resident: [],
      staff: [],
      contractor: [],
      industry_professional: [],
      agency: [],
      volunteer: [],
      other: []
    },
    checked_ids: [],
    notes: "",
    amendable: false,

    loaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleCheckbox(event) {
    let name = parseInt(event.target.name);
    let checked = this.state.checked_ids.includes(name);

    if (checked) {
      this.setState(prevState => ({
        checked_ids: prevState.checked_ids.filter(element => element !== name)
      }))
    }
    else {
      this.setState(prevState => ({
        checked_ids: prevState.checked_ids.concat(name)
      }))
    }
  }

  handleSubmit(event) {
    // collect every person
    let people = this.state.people

    let fire_log_people = []

    // manipulate person object to fire_log specification
    people.forEach((person) => {
      fire_log_people.push({
        id: person.id,
        name: person.name,
        check_in: person.check_in,
        checked: this.state.checked_ids.includes(person.id),
        type_of_person: person.type_of_person
      })
    })

    const id = this.props.id
    const json = JSON.stringify({
      "fire_log": {
        "people": fire_log_people,
        "completed": true
      }
    })

    this.setState({updating: true})
    request("PUT", `/v1/a/fire_logs/${id}`, json, () => {this.setState({unauthorized: true})})
      .then(data => {
        this.setState({ updating: false, errors: "" })
        sessionStorage.setItem("updateSuccess", this.completeMessage());
      })
      .catch(error => handleRequestErrors(this, error, { updating: false, loaded: true }))

    event.preventDefault();
  }

  completeMessage() {
    return "Fire Log completed! Emails will be send to assigned Users."
  }

  handleEmailChange(event) {
    const value = event.target.value;

    this.setState({email: value})

    event.preventDefault();
  }

  handleSendEmail() {
    const json = JSON.stringify({
      "fire_log": {
        "email": this.state.email
      }
    })

    request("POST", `/v1/a/fire_logs/${this.props.id}/send_email`, json, () => {this.setState({unauthorized: true})})
      .then(data => {
        sessionStorage.setItem("updateSuccess", "Fire Log emailed successfully!");
        this.forceUpdate()
      })
      .catch(error => {
        handleRequestErrors(this, error)
        
        if (!(error instanceof Error)) {
          sessionStorage.setItem("updateSuccess", error.errors);
          this.forceUpdate()
        }
      })
  }

  writeAccess() {
    const access = localStorage.getItem("access_levels");
    return access !== null && (access.includes("admin") || access.includes("emergency"))
  }

  renderErrors() {
    if (this.state.errors.length > 1) {
      this.state.errors.map((error, index) => (
        <div className="error" key={index}>{this.state.errors[index]}</div>
      ))
    }
  }

  renderSaveButton() {
    if (this.props.writeAccess && this.state.amendable) {
      return(
        <div>
          <input type="submit" value="Complete" onClick={this.handleSubmit} disabled={this.state.updating} />
        </div>
      )
    }
  }

  personTypeBlock(personType, people) {
    if (people && people.length !== 0) {
      return (
        <React.Fragment key={personType}>
          <h3 className="widget-title">{personType}</h3>
          {people.map((person) => (
            <div className="inline-grid" key={person.id}>
              <input className="column" type="checkbox" id={person.id} name={person.id} onChange={this.handleCheckbox} disabled={!(this.props.writeAccess && this.state.amendable)} checked={this.state.checked_ids.includes(person.id)} />
              <label className="column checkbox-label" htmlFor={person.id}>
                <div className="person-details">
                  <div>{person.name}</div>
                  <div className="center">-</div>
                  <div>Arrived:</div>
                  <div className="center">-</div>
                  <div className="center">{person.check_in}</div>
                </div>
              </label>
            </div>
          ))}
        </React.Fragment>
      )
    }
  }

  renderUserName(user_name) {
    if (this.state.user_id) {
      return user_name
    }

    return <>{user_name} <HelpText className="inline-block" page={'fire_log'} section={'author'} /></>
  }

  render() {
    const { people, order, notes, user_id, user_name, online, loaded, unauthorized, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      const total = people.visitor.length + people.resident.length + people.staff.length + people.contractor.length + people.industry_professional.length + people.agency.length + people.volunteer.length + people.other.length
      const accountedFor = this.state.checked_ids.length
      const unaccountedFor = total - accountedFor

      return (
          <div className="settings">
            <SetTitle title={`Fire Log | Locations`} />
            <PopupBox/>

            <h3>Fire Log submitted by <ConditionalLink url={`/settings/users/${user_id}`} condition={this.props.readAccess && user_id}> {this.renderUserName(user_name)}</ConditionalLink></h3>
            <div className="green-button bottom-margin" onClick={this.handleSendEmail}>Send Email</div>

              {!online &&
                <NoticeBox type="info" text="This Fire Log was completed on an offline Device. Any check ins or check outs performed on other devices during the time the Device was offline may not be represented in this Fire Log. There will also be less information showing when People checked in." />
              }

              <div className="people-count">
                {order.map((type_of_person) => (
                  <div key={type_of_person}><span className="count-title">{spaceAndCapitalize(type_of_person)}</span>: {people[type_of_person].length}</div>
                ))}
              </div>

              <div className="people-count margin-top">
                <div><span className="count-title">Total</span>: {total}</div>
                <div><span className="count-title">Accounted for</span>: {accountedFor}</div>
                { unaccountedFor > 0 &&
                  <div><span className="count-title">Unaccounted for</span>: {unaccountedFor}</div>
                }
              </div>
            <div className="person-type settings big-settings">

              {order.map((type_of_person) => (
                this.personTypeBlock(spaceAndCapitalize(type_of_person), people[type_of_person])
              ))}

              {notes !== "" && (
                <div className="margin-top">
                  <h3 className="widget-title">Notes</h3>
                  <div>{formatNewLines(notes)}</div>
                </div>
              )}
            </div>
            {this.renderErrors()}
            {this.renderSaveButton()}

            <Audits klass="FireLog" id={this.props.id} />
          </div>
      );
    }
  }

  componentDidMount() {
    let id = this.props.id;

    request("GET", `/v1/a/fire_logs/${id}`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        // turned `checked` property into array of checked_ids
        let checked_ids = data.people.filter((person) => person.checked === true).map(person => person.id)
        // seperate people by type_of_person
        let people = {
          "visitor": [],
          "resident": [],
          "staff": [],
          "contractor": [],
          "industry_professional": [],
          "agency": [],
          "volunteer": [],
          "other": []
        };

        data.people.forEach((person) => {
          // Fix for dr-device `singularize` bug
          if (person.type_of_person === "agencie") {
            person.type_of_person = "agency"
          }

          people[person.type_of_person].push(person)
        })

        this.setState({
          people: people,
          checked_ids: checked_ids,
          order: data.order,
          notes: data.notes,
          amendable: data.amendable,
          user_id: data.user_id,
          user_name: data.user_name,
          online: data.online,
          loaded: true
        })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default UpdateFireLog;
